import { isUser, User } from "../models";
import { BaseController } from "./baseController";

const getSettings = BaseController.GetFn("/MVC/Settings");

export const UserInfoApi = {
	getUserInfo: async () => {
		const userInfo = await getSettings<User>("GetUserInfo");
		return isUser(userInfo) ? userInfo : null;
	},
};
